import dayjs from "dayjs";

interface DraftDates {
  start_date: string | null;
  end_date: string | null;
}

interface ExistingSession {
  id?: number | string;
  start_date?: number | null;
  end_date?: number | null;
}

export const hasSessionOverlap = (
  draft: DraftDates,
  existingSessions: ExistingSession[] | undefined | null,
  editSessionId?: number | string,
): boolean => {
  if (!draft.start_date || !draft.end_date) return false;
  const newStart = dayjs(draft.start_date).valueOf();
  const newEnd = dayjs(draft.end_date).valueOf();

  return (existingSessions || []).some((s) => {
    if (editSessionId != null && String(s?.id) === String(editSessionId)) {
      return false;
    }
    if (s?.start_date == null || s?.end_date == null) return false;
    const start = dayjs(s.start_date).valueOf();
    const end = dayjs(s.end_date).valueOf();
    const noOverlap =
      (newStart < start && newEnd < start) || (newStart > end && newEnd > end);
    return !noOverlap;
  });
};

export const totalMinutesWith = (
  draft: DraftDates,
  existingSessions: ExistingSession[] | undefined | null,
  editSessionId?: number | string,
): number => {
  let total = 0;
  for (const s of existingSessions || []) {
    if (editSessionId != null && String(s?.id) === String(editSessionId)) {
      continue;
    }
    if (s?.start_date == null || s?.end_date == null) continue;
    total += Math.abs(dayjs(s.end_date).diff(dayjs(s.start_date), "minute"));
  }
  if (draft.start_date && draft.end_date) {
    total += Math.abs(
      dayjs(draft.end_date).diff(dayjs(draft.start_date), "minute"),
    );
  }
  return total;
};
